import React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select'
import RaceClock from './RaceClock';
import {selectEvent, performSearch} from '../actions/race';

class ResultsHeader extends React.Component {

  constructor(props) {
    super(props);

    // console.log(props);

    this.state = {
      search: '',
      div: this.props.division || 'ALL'
    };

    // this.props.performSearch(this.state.search, this.state.div);
    // this.props.onSearch();
  }

  componentWillReceiveProps(newProps) {
    // console.log(newProps);
    if (this.state.div !== newProps.division) {
      this.setState({div: newProps.division});
      this.props.performSearch(this.state.search, newProps.division);
      // this.props.onSearch();
    }
  }

  changeEvent(event) {

    if (this.props.raceDetail.txt_results && this.props.raceDetail.txt_results[this.props.eventId]) {
      this.props.history.push(`/race/${this.props.raceDetail.race_id}/${event.value}/results/`);
    } else {

      this.props.history.push(`/race/${this.props.raceDetail.race_id}/${event.value}`);
    }
  }

  changeDivision(e) {
    const newDiv = e ? e.value : 'ALL';

    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId || ''}/results/${newDiv}`);

    // this.setState({div: newDiv});
    // this.props.performSearch(this.state.search, newDiv);
    // this.props.onSearch();
  }

  navigateToRunner(bib) {
    this.props.history.push(`/race/${this.props.raceDetail.race_id}/${this.props.eventId}/${bib}`);
  }


  handleSearchChange(e) {
    e.preventDefault();
    this.setState({search: e.target.value});
  }

  handleSearch(e) {
    e.preventDefault();
    e.stopPropagation();
    if (isNaN(parseInt(this.state.search))) {
      this.props.performSearch(this.state.search, this.state.div);
      this.props.onSearch();
    } else {
      this.navigateToRunner(parseInt(this.state.search));
    }
    return false;
  }

  render() {

    const eventOptions = this.props.raceDetail.event_mapping.filter((e) => {
      return this.props.raceDetail.event_metadata[e.key] && (!this.props.raceDetail.event_metadata[e.key].hide || this.props.raceDetail.event_metadata[e.key].hide === 'false');
    }).map((e) => {
      return {value: e.key, label: e.name.toUpperCase()};
    });

    let divs = this.props.raceDetail.divisions;
    if (this.props.raceDetail.event_metadata[this.props.eventId] && this.props.raceDetail.event_metadata[this.props.eventId].divisions) {
      divs = this.props.raceDetail.event_metadata[this.props.eventId].divisions;
    }
    const divOptions = divs.map((div) => { return {value: div, label: div.toUpperCase()}; });


    const textResults = this.props.raceDetail.event_metadata && this.props.raceDetail.event_metadata[this.props.eventId] && this.props.raceDetail.event_metadata[this.props.eventId].txt_results;

    return (
      <div className="main-head">
        <div className="row">
          <div className="cols clearfix">
            {eventOptions && eventOptions.length > 0 &&
              <div className="col col-size1">
                {this.props.raceDetail.event_mapping &&
                <div className="select">
                  <span style={{display: 'inline', position: 'relative', top: '-15px', marginRight: '10px'}}>Event:</span>
                  <div style={{display: 'inline-block'}}>
                    <Select
                      name="form-field-name"
                      value={this.props.eventId}
                      options={eventOptions}
                      onChange={this.changeEvent.bind(this)}
                      clearable={false}
                      boolean={false}
                    />
                  </div>
                </div>
              }
            </div>
          }

            <div className="col col-size2">
              {!textResults && this.props.raceDetail.divisions && Object.keys(this.props.raceDetail.divisions).length > 1 &&
              <div className="select select-xsmall">
                <Select
                  name="form-field-name"
                  value={this.state.div}
                  options={divOptions}
                  onChange={this.changeDivision.bind(this)}
                  clearable={false}
                  placeholder='Filter Division...'
                  boolean={false}
                  filterOptions={false}
                />
              </div>
              }
            </div>
          </div>
        </div>

        <div className="row">
          <div className="cols clearfix">
            <div className="col col-size1">
              {!textResults &&
              <div className="search">
                <form onSubmit={this.handleSearch.bind(this)}>
                  <label htmlFor="q" className="hidden">Search</label>

                  <input type="text" name="search" id="search" placeholder="Search by name or bib"
                         value={this.state.search}
                         onChange={this.handleSearchChange.bind(this)}
                         title="Search by name or bib" className="search-field"/>

                       <button type="submit" className="search-btn" id="searchButton" style={{backgroundColor: this.props.color }}>
                    <i className="ico-search"/>
                  </button>
                </form>
              </div>
              }
            </div>

            {/*<div className="col col-size2">*/}
              {/*<RaceClock/>*/}
            {/*</div>*/}
          </div>
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    eventId: state.rr360.eventId,
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, {selectEvent, performSearch})(ResultsHeader);



// WEBPACK FOOTER //
// ./src/components/ResultsHeader.js